import React from 'react';

const PositionSummary = ({ positionRequirements, candidates = [] }) => {
  if (!positionRequirements || Object.keys(positionRequirements).length === 0) return null;

  const {
    position_title = 'N/A',
    required_experience_years = 0,
    department = 'N/A',
    grade = 'N/A',
    location = 'N/A'
  } = positionRequirements;

  // The backend reports per candidate how relevance was decided; show what actually ran.
  const notAssessed = candidates.filter((c) => c.relevance_method === 'not_assessed').length;

  return (
    <section className="block">
      <div className="section-head">
        <h2><i className="fas fa-bullseye"></i> Target position analysis</h2>
        <span className="sub">All candidates scored against these requirements</span>
      </div>
      <div className="card card-pad">
        <div className="psgrid">
          <div className="psrow"><span className="k">Position title</span><span className="v big">{position_title}</span></div>
          <div className="psrow"><span className="k">Grade</span><span className="v"><span className="chip info">{grade}</span></span></div>
          <div className="psrow"><span className="k">Department</span><span className="v">{department}</span></div>
          <div className="psrow"><span className="k">Required experience</span><span className="v"><span className="chip warn">{required_experience_years} years minimum</span></span></div>
          <div className="psrow"><span className="k">Duty station</span><span className="v">{location}</span></div>
          <div className="psrow"><span className="k">Analysis method</span><span className="v">
            {notAssessed === 0 && 'AI relevance scoring'}
            {notAssessed > 0 && <span className="chip warn">Relevance not assessed: {notAssessed} of {candidates.length} (no step given)</span>}
          </span></div>
        </div>
      </div>
    </section>
  );
};

export default PositionSummary;
